import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { IOneToOneMeetingsList } from '@components/onetoonemeetings';
import { ErrorHandler } from '@helper/errorHandler';
import { usePermissionCheckForApiCallback } from '../../../authGuard';

export const useGetOneToOneMeetingsList = (): IQueryResponse<IOneToOneMeetingsList[]> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('one_to_one_meetings');
	const { permissionForApi } = usePermissionCheckForApiCallback({ componentName: 'OneToOneMeetings' });
	const fetchOneToOneMeetingsList = async (): Promise<IOneToOneMeetingsList[]> => {
		try {
			const response = await APIService.getData<IOneToOneMeetingsList[]>(APICONFIG.ONE_TO_ONE_MEETINGS_LIST, {
				limit: '0',
			});
			if (response) {
				const data = response.map((item) => {
					return { ...item, id: item?.id?.toString() };
				});
				await setRxdb('one_to_one_meetings', data);
			}
			return response;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['oneToOneMeetingsList'],
		queryFn: fetchOneToOneMeetingsList,
		retry: false,
		staleTime: 30 * 60 * 1000,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
		enabled: permissionForApi ? isDbChecked && shouldFetch : false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
